"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __importDefault(require("../Store"));
var libzl_1 = require("./libzl");
function collectMetadata(envCB, thumbsCB, allCodesCB, streamEnvCB, doneCB) {
    libzl_1.zlQueryMetadata(function (assets) {
        var _a;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!assets) {
            console.error("Failed to load metadata");
            doneCB(false);
            return;
        }
        var envThumbs = {};
        var carThumbs = {};
        var carThumbData = {};
        var baseURL = "";
        var allAvailablePrcodes = {};
        var sourcedPrcodes = {};
        var sourcedArray = [];
        var masterLibrary = null;
        try {
            var g = assets.assets.generic;
            var comps = Object.keys(g);
            var currBrand = process.env.REACT_APP_BRP_BRAND;
            if (currBrand === "canamoffroad") {
                currBrand = "canam";
            }
            for (var c = 0; c < comps.length; c++) {
                var comp = comps[c];
                if (window.zlurlparams.localstream) {
                    baseURL = window.location.protocol + "//" + window.zlurlparams.localstream + "/zlm";
                }
                else if (assets.frontEndContent !== undefined) {
                    baseURL = assets.frontEndContent.baseURL;
                }
                if (g[comp].allavailableprcodes !== undefined) {
                    allAvailablePrcodes = __assign(__assign({}, allAvailablePrcodes), (_c = (_b = g[comp].allavailableprcodes) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.data);
                }
                if (g[comp].sourcedprcodes !== undefined) {
                    sourcedPrcodes = __assign(__assign({}, sourcedPrcodes), g[comp].sourcedprcodes.metadata.data);
                }
                if (g[comp].carthumbnails !== undefined) {
                    var assetComps = comp.split(".");
                    if (assetComps.length >= 4 && (assetComps[0] === "car" || assetComps[2] === "miscellaneous")) {
                        var model_1 = assetComps[2];
                        var year_1 = assetComps[3];
                        if (!(model_1 in carThumbData)) {
                            carThumbData[model_1] = {};
                        }
                        carThumbData[model_1][year_1] = g[comp].carthumbnails["metadata"];
                    }
                }
                if (((_e = (_d = g[comp].frontendcontent) === null || _d === void 0 ? void 0 : _d.metadata) === null || _e === void 0 ? void 0 : _e.data) !== undefined) {
                    console.log(comp + " frontendcontent", g[comp].frontendcontent);
                    var compBrand = comp.split(".")[2].replace(/-/g, "");
                    var assetrefs = Object.keys(g[comp].frontendcontent.metadata.data);
                    for (var index in assetrefs) {
                        var assetRef = assetrefs[index];
                        if (assetRef.startsWith("env.")) {
                            envThumbs[assetRef.split(".")[1]] = g[comp].frontendcontent.metadata.data[assetRef]["thumbnail_medium"];
                        }
                        else if (assetRef.startsWith("car.") || (assetRef.startsWith("thumbs."))) {
                            var assetComps = assetRef.split(".");
                            var model_2 = assetComps[2];
                            var year_2 = assetComps[3];
                            if (!(model_2 in carThumbs)) {
                                carThumbs[model_2] = {};
                            }
                            if (!(year_2 in carThumbs[model_2])) {
                                carThumbs[model_2][year_2] = {};
                            }
                            var isMasterLibrary = assetRef.includes("master_look_library");
                            for (var prCode in g[comp].frontendcontent.metadata.data[assetRef]) {
                                if (baseURL.length > 0) {
                                    if (currBrand === compBrand) {
                                        carThumbs[model_2][year_2][prCode] = g[comp].frontendcontent.metadata.data[assetRef][prCode];
                                    }
                                    if (isMasterLibrary) {
                                        //current mismatch between master library and car so have both ways
                                        if (currBrand === compBrand) {
                                            carThumbs[model_2][year_2][prCode.replace(/-/g, "_")] = g[comp].frontendcontent.metadata.data[assetRef][prCode];
                                        }
                                    }
                                }
                                else {
                                    carThumbs[model_2][year_2][prCode] = "None";
                                }
                            }
                            if (isMasterLibrary) {
                                masterLibrary = __assign(__assign({}, (masterLibrary || {})), carThumbs[model_2][year_2]);
                            }
                        }
                    }
                }
            }
            var manufacturer = "";
            var model = "";
            var year = "";
            var carmeta = undefined;
            var platform_modelyear = (window.zlurlparams.platform + "_" + window.zlurlparams.modelyear).toLowerCase();
            for (var _i = 0, _l = Object.keys(assets.assets.cars); _i < _l.length; _i++) {
                var vehicleassetref = _l[_i];
                var aliases = (_f = assets.assets.cars[vehicleassetref].metadata) === null || _f === void 0 ? void 0 : _f.aliases;
                if (Array.isArray(aliases)) {
                    console.log(vehicleassetref + " Aliases", aliases);
                    if (aliases.includes(platform_modelyear)) {
                        _a = vehicleassetref.split(" "), manufacturer = _a[0], model = _a[1], year = _a[2];
                        carmeta = assets.assets.cars[vehicleassetref].metadata;
                        break;
                    }
                }
            }
            //Fallback to old method, can remove once new assets are deployed to Lynx & Can-Am On-Road
            if ((!manufacturer || !model || !year) && process.env.REACT_APP_VEHICLEOVERRIDES) {
                var overrides = JSON.parse(atob(process.env.REACT_APP_VEHICLEOVERRIDES));
                console.log("Falling back to old master model determination", overrides);
                if (overrides) {
                    var platform_modelyear_package = (platform_modelyear + "_" + window.zlurlparams.package).toLowerCase();
                    if (overrides.hasOwnProperty(platform_modelyear_package)) {
                        manufacturer = overrides[platform_modelyear_package].brand;
                        model = overrides[platform_modelyear_package].model;
                        year = overrides[platform_modelyear_package].year;
                    }
                    else if (overrides.hasOwnProperty(platform_modelyear)) {
                        manufacturer = overrides[platform_modelyear].brand;
                        model = overrides[platform_modelyear].model;
                        year = overrides[platform_modelyear].year;
                    }
                    carmeta = assets.assets.cars[manufacturer + " " + model + " " + year].metadata;
                }
            }
            var ignoreAttachPoints = false;
            var aref = "car." + [manufacturer, model, year].join(".");
            if (aref in sourcedPrcodes) {
                sourcedArray = sourcedPrcodes[aref].prcodes;
                if (sourcedPrcodes[aref].useLibrary) {
                    var regex = new RegExp("^car." + sourcedPrcodes[aref].useLibrary);
                    for (var _m = 0, _o = Object.keys(sourcedPrcodes); _m < _o.length; _m++) {
                        var item = _o[_m];
                        if (sourcedPrcodes[item].isLibrary && regex.test(item)) {
                            sourcedArray = sourcedArray.concat(sourcedPrcodes[item].prcodes);
                        }
                    }
                }
                else if (!sourcedPrcodes[aref].isLibrary) {
                    ignoreAttachPoints = true;
                }
            }
            console.log("Car Metadata:", carmeta);
            if (streamEnvCB) {
                console.log("streamEnvCB", manufacturer, model, year);
                streamEnvCB({
                    "viewer": assets.viewer ? assets.viewer : "local?",
                    "assets": assets.assetsManifest ? assets.assetsManifest.info : "local?",
                    "vehicle": assets.assets.cars || {},
                    "environment": assets.assets.environments || {},
                    "mastermodel": {
                        manufacturer: manufacturer,
                        model: model,
                        year: year
                    },
                    "uiblacklist": (carmeta === null || carmeta === void 0 ? void 0 : carmeta.uiBlacklist) || [],
                    "apidataextras": carmeta === null || carmeta === void 0 ? void 0 : carmeta.injectAPIData,
                    "ignoreattachpoints": ignoreAttachPoints
                });
            }
            if (allCodesCB) {
                if (sourcedArray.length) {
                    var finalCodes_1 = {};
                    sourcedArray.forEach(function (element) {
                        finalCodes_1[element] = {};
                    });
                    allCodesCB(finalCodes_1);
                }
                else {
                    allCodesCB(allAvailablePrcodes);
                }
            }
        }
        catch (err) {
            console.log("Could not get asset metadata", err);
        }
        var finalCarThumbData = {};
        for (var model in carThumbData) {
            for (var year in carThumbData[model]) {
                if (model in carThumbs) {
                    if (year in carThumbs[model]) {
                        if (!(model in finalCarThumbData)) {
                            finalCarThumbData[model] = {};
                        }
                        var startingPoint = finalCarThumbData[model];
                        if (model !== "accessories") {
                            startingPoint[year] = {};
                            startingPoint = startingPoint[year];
                        }
                        var hasThumbnailList = (_h = (_g = carThumbData[model][year]) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.hasThumbnail;
                        var altThumbs = (_k = (_j = carThumbData[model][year]) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.altThumbs;
                        //get main pr codes and any alt camera screenshots associated with them
                        for (var prCodeIndex in hasThumbnailList) {
                            var prCode = hasThumbnailList[prCodeIndex];
                            var thisPrCodeThumbData = {};
                            if (baseURL.length > 0) {
                                thisPrCodeThumbData["path"] = carThumbs[model][year][prCode];
                            }
                            else {
                                thisPrCodeThumbData["path"] = "None";
                            }
                            thisPrCodeThumbData["hasThumb"] = true;
                            thisPrCodeThumbData["altThumbs"] = {};
                            for (var altThumbIndex in altThumbs) {
                                var altThumbName = altThumbs[altThumbIndex];
                                if (altThumbName.includes(prCode)) {
                                    var camera = altThumbName.replace(prCode + "_", "");
                                    thisPrCodeThumbData["altThumbs"][camera] = carThumbs[model][year][altThumbName];
                                }
                            }
                            startingPoint[prCode] = thisPrCodeThumbData;
                        }
                        //anything else should be a placeholder
                        for (var prCode in carThumbs[model][year]) {
                            if (!(prCode in startingPoint) && !(altThumbs === null || altThumbs === void 0 ? void 0 : altThumbs.includes(prCode))) {
                                var thisPrCodeThumbData = {};
                                if (baseURL.length > 0) {
                                    thisPrCodeThumbData["path"] = carThumbs[model][year][prCode];
                                }
                                else {
                                    thisPrCodeThumbData["path"] = "None";
                                }
                                thisPrCodeThumbData["hasThumb"] = false;
                                thisPrCodeThumbData["altThumbs"] = {};
                                startingPoint[prCode] = thisPrCodeThumbData;
                            }
                        }
                    }
                }
            }
        }
        finalCarThumbData["baseurl"] = baseURL;
        thumbsCB(finalCarThumbData, masterLibrary);
        var getEnvThumb = function (e) {
            if (baseURL.length > 0 && envThumbs[e.toLowerCase()] !== undefined) {
                return baseURL + envThumbs[e.toLowerCase()];
            }
            return "https://via.placeholder.com/512x512/" + (e.indexOf("green") >= 0 ? '008000' : 'fafafa') + ("/?text=" + encodeURIComponent(e.split("_")[e.split("_").length - 1]));
        };
        var environments = Object.keys(assets.assets.environments).filter(function (e) { return e.indexOf("void") < 0; }).map(function (env) {
            return {
                id: env,
                name: env,
                image: getEnvThumb(env)
            };
        });
        envCB(environments);
        doneCB(true);
    }, function () {
        doneCB(false);
    });
}
exports.collectMetadata = collectMetadata;
function isEnvironmentAvailable(env) {
    var _a, _b;
    var state = Store_1.default.getState();
    var envdatas = state.EnvironmentInfo.environment;
    var lineup = (_a = state.BuildSession.current) === null || _a === void 0 ? void 0 : _a.getProductLineUp();
    if (envdatas && lineup) {
        var envdata = envdatas[env];
        if ((_b = envdata === null || envdata === void 0 ? void 0 : envdata.metadata) === null || _b === void 0 ? void 0 : _b.whitelist) {
            return envdata.metadata.whitelist.includes(lineup);
        }
    }
    return true;
}
exports.isEnvironmentAvailable = isEnvironmentAvailable;
function getEnvironmentSortKey(env) {
    var _a, _b, _c, _d;
    var state = Store_1.default.getState();
    return (_d = (_c = (_b = (_a = state.EnvironmentInfo.environment) === null || _a === void 0 ? void 0 : _a[env]) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.sortkey) !== null && _d !== void 0 ? _d : 0;
}
exports.getEnvironmentSortKey = getEnvironmentSortKey;
function processLogic(codes, logic) {
    if (!logic) {
        return false;
    }
    if (logic.not) {
        return !processLogic(codes, logic.not);
    }
    else if (logic.xor) {
        return logic.xor.reduce(function (count, l) { return count + (processLogic(codes, l) ? 0 : 1); }, 0) === 1;
    }
    else if (logic.or) {
        return logic.or.some(function (l) { return processLogic(codes, l); });
    }
    else if (logic.and) {
        return logic.and.every(function (l) { return processLogic(codes, l); });
    }
    if (typeof (logic) === "string") {
        return codes.map(function (c) { return c.toLowerCase(); }).includes(logic.toLowerCase());
    }
    return true;
}
exports.processLogic = processLogic;
function isCodeVisual(code, appliedCodes) {
    var _a;
    var returnVal = {};
    if (!code) {
        return returnVal;
    }
    var state = Store_1.default.getState();
    var bs = state.BuildSession.current;
    var market = ((_a = bs === null || bs === void 0 ? void 0 : bs.session) === null || _a === void 0 ? void 0 : _a.country) || "";
    var codes = (appliedCodes ? appliedCodes : bs === null || bs === void 0 ? void 0 : bs.getPRCodes()) || [];
    var cardata = state.EnvironmentInfo.vehicle;
    if (cardata !== undefined && Object.keys(cardata).length > 0) {
        var car = state.EnvironmentInfo.mastermodel;
        var id = [car.manufacturer, car.model, car.year].join(" ");
        var carmeta = cardata[id] || Object.values(cardata)[0];
        if (carmeta.metadata) {
            if (carmeta.metadata.codeTranslation) {
                var whitelist = carmeta.metadata.codeTranslation.whitelist;
                if (whitelist && !whitelist.some(function (c) { var _a; return c === code || (c.code === code && (!((_a = c.country) === null || _a === void 0 ? void 0 : _a.length) || c.country.includes(market)) && processLogic(codes, c)); })) {
                    if (!window.zlurlparams.ignore3DBlacklist) {
                        returnVal.show = false;
                    }
                    returnVal.wl = true;
                }
                else
                    returnVal.wl = false;
                var blacklist = carmeta.metadata.codeTranslation.blacklist || [];
                if (blacklist.some(function (c) { var _a; return c === code || (c.code === code && (!((_a = c.country) === null || _a === void 0 ? void 0 : _a.length) || c.country.includes(market)) && processLogic(codes, c)); })) {
                    if (!window.zlurlparams.ignore3DBlacklist) {
                        returnVal.show = false;
                    }
                    returnVal.bl3d = true;
                }
                else
                    returnVal.bl3d = false;
            }
            if (carmeta.metadata.uiBlacklist) {
                var uiBlacklist = carmeta.metadata.uiBlacklist || [];
                if (uiBlacklist.some(function (c) { var _a; return c === code || (c.code === code && (!((_a = c.country) === null || _a === void 0 ? void 0 : _a.length) || c.country.includes(market)) && processLogic(codes, c)); })) {
                    returnVal.blui = true;
                }
                else
                    returnVal.blui = false;
            }
        }
    }
    if (returnVal.show !== false) {
        var codes_1 = state.UI.allcodes;
        if (codes_1) {
            var val = code.toUpperCase() in codes_1;
            returnVal.show = val;
            return returnVal;
        }
    }
    // need to hook up the metadata on local streams so we don't have to assume everything is visual in such cases
    return returnVal;
}
exports.isCodeVisual = isCodeVisual;
function filterNonVisualCodes(modelName, modelYear, codes) {
    var finalCodes = codes.filter(function (code) {
        if (isCodeVisual(code, codes).show === false) {
            console.log("Filtering non visual code: ", code);
            return false;
        }
        return true;
    });
    if (window.zlurlparams.ignore3DBlacklist) {
        finalCodes.push("ignore3D");
    }
    if (window.zlurlparams.ignoreUIBlacklist) {
        finalCodes.push("ignoreUI");
    }
    return finalCodes;
}
exports.filterNonVisualCodes = filterNonVisualCodes;
function getCameraThumb(buildSession, alt, altName) {
    var _a;
    var state = Store_1.default.getState();
    var thumbs = state.UI.thumbs;
    var _b = (_a = state.EnvironmentInfo) === null || _a === void 0 ? void 0 : _a.mastermodel, modelName = _b.model, modelYear = _b.year;
    var cameraImgName = "";
    var thumbData = thumbs.thumbData;
    if (thumbData) {
        if (!thumbData["baseurl"]) {
            return null;
        }
        if (modelName in thumbData) {
            var modelThumbs = thumbData[modelName];
            if (modelYear in modelThumbs) {
                var yearThumbs_1 = modelThumbs[modelYear];
                var prcodes_1 = new Set(buildSession.getPRCodes().map(function (prcode) { return prcode.toUpperCase(); }));
                var matches = Object.keys(yearThumbs_1).filter(function (code) { return yearThumbs_1[code].hasThumb; }).sort(function (lhs, rhs) {
                    var getCount = function (key) {
                        return key.split("__").filter(function (code) { return prcodes_1.has(code.replace(/^SWITCH_/g, "")); }).length;
                    };
                    return getCount(rhs) - getCount(lhs); //Most matches first
                });
                var bestMatch = yearThumbs_1[buildSession.getModelSku().toUpperCase()] || (matches.length > 0 && yearThumbs_1[matches[0]]);
                if (alt) {
                    if (bestMatch) {
                        for (var altKey in bestMatch["altThumbs"]) {
                            if (altKey.includes(altName)) {
                                return thumbData["baseurl"] + bestMatch["altThumbs"][altKey];
                            }
                        }
                    }
                    if (cameraImgName.length === 0) {
                        for (var altKey in yearThumbs_1) {
                            if (altKey.includes(altName)) {
                                return thumbData["baseurl"] + yearThumbs_1[altKey]["path"];
                            }
                        }
                    }
                }
                return thumbData["baseurl"] + bestMatch["path"];
            }
        }
    }
    return null;
}
exports.getCameraThumb = getCameraThumb;
function _getColorThumb(thumbs, id, modelName, modelYear, segment, sanitisedID) {
    if (thumbs.masterLibrary) {
        var masterID = id.toUpperCase().replace("COLOR_", "");
        segment = segment.toUpperCase();
        while (masterID.includes("_")) {
            if (segment + "_" + masterID in thumbs.masterLibrary) {
                return thumbs.masterLibrary[segment + "_" + masterID];
            }
            if (masterID in thumbs.masterLibrary) {
                return thumbs.masterLibrary[masterID];
            }
            var end = masterID.lastIndexOf("_");
            if (end === -1) {
                break;
            }
            else {
                masterID = masterID.slice(0, end);
            }
        }
    }
    var thumbData = thumbs.thumbData;
    if (thumbData !== undefined) {
        if (modelName in thumbData) {
            var modelThumbs = thumbData[modelName];
            if (modelYear in modelThumbs) {
                if (modelThumbs[modelYear][sanitisedID] !== undefined) {
                    return modelThumbs[modelYear][sanitisedID].path;
                }
            }
        }
    }
}
function isItemColor(id) {
    // would be better to have the category in the item info, or add an API function to check this
    // (but at least by using this function we're only hacking it in once place)
    return id.startsWith("color_");
}
exports.isItemColor = isItemColor;
function getItemThumb(buildSession, id, category, svgs) {
    if (isItemColor(id)) {
        var thumbs = Store_1.default.getState().UI.thumbs;
        if (thumbs.thumbData !== undefined && thumbs.thumbData["baseurl"]) {
            var modelName = buildSession.getModelRangeName();
            var modelYear = buildSession.getModelYear();
            var modelType = buildSession.getModelType();
            var thumbName = _getColorThumb(thumbs, id, modelName, modelYear, modelType, id.toUpperCase());
            return { icon: thumbName ? thumbs.thumbData["baseurl"] + thumbName : undefined, fallback: svgs.icon_color };
        }
    }
    if (buildSession && id !== "") {
        var engine = getEngineIconName(buildSession, id);
        if (!engine && id.includes("ENGINE")) {
            engine = getEngineIconName(buildSession);
        }
        if (engine) {
            return { icon: svgs[engine], fallback: svgs.icon_engine };
        }
    }
    var icon = undefined;
    var fallback = undefined;
    if (id) {
        id = id.toLowerCase();
        for (var _i = 0, _a = Object.keys(svgs); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key.startsWith("icon_") && id.endsWith(key.substr(5))) {
                icon = svgs[key];
            }
            else if (key.startsWith("icon_") && id.includes(key.substr(5))) {
                icon = svgs[key];
            }
        }
    }
    if (category) {
        category = category.toLowerCase();
        for (var _b = 0, _c = Object.keys(svgs); _b < _c.length; _b++) {
            var key = _c[_b];
            if (key.startsWith("icon_") && category.endsWith(key.substr(5))) {
                fallback = svgs[key];
            }
            else if (key.startsWith("icon_") && category.includes(key.substr(5))) {
                fallback = svgs[key];
            }
        }
    }
    return { icon: icon, fallback: fallback };
}
exports.getItemThumb = getItemThumb;
var ENGINE_THUMB_MAP = (process.env.REACT_APP_ENGINE_THUMB_MAP || "").split(",").map(function (p) { return p.split("="); }).filter(function (c) { return c[0] && c[1]; }).reduce(function (p, c) {
    var _a;
    return (__assign(__assign({}, p), (_a = {}, _a[c[0]] = c[1], _a)));
}, {});
function getEngineIconName(buildSession, id) {
    if (id && ENGINE_THUMB_MAP[id]) {
        return ENGINE_THUMB_MAP[id];
    }
    if (buildSession && id) {
        var bracket = buildSession.getEngineBracket(id);
        if (bracket === 0) {
            return "icon_engine";
        }
        else if (bracket > 0) {
            if (bracket > 2) {
                bracket = 2;
            }
            return "icon_engine_" + (bracket + 1);
        }
    }
    // not an engine.
    return null;
}
exports.getEngineIconName = getEngineIconName;
function getMiscellaneousThumb(id) {
    var thumbs = Store_1.default.getState().UI.thumbs;
    var thumbData = thumbs.thumbData;
    if (thumbData && ("miscellaneous" in thumbData)) {
        for (var year in thumbData["miscellaneous"]) {
            if (id in thumbData["miscellaneous"][year]) {
                return thumbs.thumbData["baseurl"] + thumbData["miscellaneous"][year][id]["path"];
            }
        }
    }
    return null;
}
exports.getMiscellaneousThumb = getMiscellaneousThumb;
function getHeroShot(buildSession, env, width, height, background_colour) {
    if (width === void 0) { width = 512; }
    if (height === void 0) { height = 512; }
    if (background_colour === void 0) { background_colour = "#00000000"; }
    return new Promise(function (resolve, reject) {
        var interval;
        var attempts = 0;
        interval = setInterval(function () {
            if (window.direct2D !== undefined && window.direct2D !== null) {
                clearInterval(interval);
                resolve(true);
            }
            else {
                attempts++;
                if (attempts >= 10) {
                    clearInterval(interval);
                    console.log("Hero shot: Direct2D not ready after " + attempts + " seconds");
                    resolve(false);
                }
            }
        }, 1000);
    }).then(function (twodready) {
        if (twodready) {
            return libzl_1.requestImage({
                size: [width, height],
                env: env,
                background_colour: background_colour
            });
        }
        else {
            return new Promise(function (resolve, reject) {
                var defImg = getCameraThumb(buildSession, false, "");
                // this is only likely to work if you were previously connect but now are not.
                if (defImg) {
                    resolve(defImg);
                }
                else {
                    // this works but its a slightly different aspect to our image so looks a bit wonky.
                    /*let mktImg = this.props.buildSession.getDefaultMarketingImage();
                    if(mktImg.length > 0){
                        resolve(mktImg);
                    }else{*/
                    reject("Direct 2d unavailable and no default image found");
                    //}
                }
            });
        }
    });
}
exports.getHeroShot = getHeroShot;
//# sourceMappingURL=metadata.js.map